import React, { useEffect, useState, Fragment } from 'react';
import ReactHtmlParser from 'html-react-parser';
import { connect } from 'react-redux';

import { getMethodologyIndicators, getMethodologyData } from '../../api';

import { setMethodology } from '../../actions/';

import menuStructure from '../../model/menu.json';

const Methodology = props => {

	const sections = [
		{
			id: 'osh-context', 
			name: 'L22001',
			firstSubsection: 'OSH authorities',
			firstIndicatorId: '27'
		},
		{
			id: 'osh-steering', 
			name: 'L22005',
			firstSubsection: 'Regulation',
			firstIndicatorId: '412'
		},
		{
			id: 'working-conditions-preventions', 
			name: 'L20025',
			firstSubsection: 'Working conditions - Overall opinion',
			firstIndicatorId: '65'
		},
		{
			id: 'accidents-diseases-well-being', 
			name: 'L22009',
			firstSubsection: 'Work accidents',
			firstIndicatorId: '53'
		},
		{
			id: 'osh-infrastructure', 
			name: 'L22016',
			firstSubsection: 'Enforcement authorities',
			firstIndicatorId: '76'
		}
	];

	const dropdownRefContainer = React.createRef();

	const [indicators, setIndicators] = useState([]);
	const [openIndicator, setOpenIndicator] = useState(false);
	const [methodology, setMethodologyData] = useState(undefined);

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22019 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		getMethodologyIndicatorsData(props.methodology.subsection);
		loadMethodologyData(props.methodology.subsection, props.methodology.indicator);

		window.addEventListener('resize', updateDimension);
		window.addEventListener('mousedown', handleClickOutside);
	}, [])

	useEffect(() => {
		getMethodologyIndicatorsData(props.methodology.subsection);
		loadMethodologyData(props.methodology.subsection, props.methodology.indicatorID);
	}, [props.methodology.section, props.methodology.subsection, props.methodology.indicatorID, props.methodology.firstIndicatorId])

	const indicatorIcons = (subsection) => {
		subsection = subsection.toLowerCase();

		switch(subsection) {
			// OSH CONTEXT
			case 'osh authorities':
				return 'forum-icon';
			case 'economic and sector profile':
				return 'economic-chart-icon';
			case 'workforce profile':
				return 'people-group-icon';
			case 'forecasts':
				return 'forecasts-icon';

			// STEERING OF OSH 
			case 'regulation':
				return 'regulation-icon';
			case 'structure of each national strategy':
				return 'national-icon';
			case 'responses of national strategies to eu challenges':
				return 'national-icon';
			case 'social dialogue in eu countries':
				return 'dialogue-icon';
			case 'social dialogue indicator':
				return 'social-dialogue-composite-icon';
			case 'worker involvement':
				return 'workers-icon';

			// WORKING CONDITIONS AND PREVENTION
			case 'working conditions - overall opinion':
				return 'overall-opinion-icon';
			case 'working conditions - mental risk':
				return 'mental-risk-icon';
			case 'working conditions - physical risk':
				return 'physical-risk-icon';
			case 'working conditions - safety risks':
				return 'safety-risk-icon';
			case 'working conditions - digitalisation risks':
				return 'digitalisation-risk-icon';
			case 'prevention in companies':
				return 'prevention-icon';
			case 'osh culture and health awareness':
				return 'culture-icon';

			// ACCIDENTS, DISEASES AND WELL-BEING
			case 'work accidents':
				return 'work-accidents-icon';
			case 'work-related diseases':
				return 'work-related-diseases-icon';
			case 'health perception of the workers':
				return 'health-icon';
			case 'workers’ health compared to peers': 
				return 'health-compared-peers-icon';
			case 'health problems caused or made worse by work':
				return 'reported-health-problems-icon';			

			// OSH INFRASTRUCTURE
			case 'enforcement authorities':
				return 'enforcement-icon';
			case 'enforcement capacity':
				return 'enforcement-capacity-icon';
			case 'osh statistics, surveys and research':
				return 'statistics-icon';
			case 'international organisations':
				return 'international-organisations-icon';
			case 'international programmes':
				return 'international-organisations-icon';

			default:
			// code block
		}    
	}

	const getMethodologyIndicatorsData = (pSection) => 
	{
		getMethodologyIndicators(pSection).then((data) => {
			setIndicators(data.resultset);
		})
	}

	const loadMethodologyData = (pSection, pIndicatorID) =>
	{
		getMethodologyData(pSection, pIndicatorID).then((data) => {
			setMethodologyData(data.resultset[0]);
		})
	}

	const methodologySection = (headerLiteralID, dataLiteralID) =>
	{
		if (props.literals[dataLiteralID] != null && props.literals[dataLiteralID] != 'null' && props.literals[dataLiteralID] != "")
		{
			return (
				<Fragment>
					<h3>{ props.literals[headerLiteralID] }</h3>
					{ReactHtmlParser(props.literals[dataLiteralID])}
				</Fragment>
			)
		}
		return null;
	}

	const updateDimension = () => {
		const width = window.innerWidth;

		if (width > 990) {
			setOpenIndicator(false);
		}
	}

	const changeMethodology = (section, subsection, indicator) =>
	{
		props.setMethodology(section,subsection,indicator);
	}

	const handleClickOutside = (event) => {
		if (dropdownRefContainer.current && !dropdownRefContainer.current.contains(event.target)) {
			setOpenIndicator(false);
		}
	}

	const openIndicatorsList = () => {
		setOpenIndicator(!openIndicator);
	}

    let levels= [];
	for (let i = 0; i < menuStructure.length; i++)
	{
		if (menuStructure[i].id == props.methodology.section)
		{
			levels = menuStructure[i].levels;
		}
	}

	return (
		<div className="about-tool">
			<div className="container">
				<h1 className="title-section second-color text-center">{ props.literals.L22019 }</h1>
				<div>
					<p className="center-text">{ props.literals.L20556 }</p>
				</div>
				{/*  SECTION MENU  */}
				<ul className="indicators--list--wrapper">
					{ sections.map((section) => (
						<li key={section.id} className={'indicators-item ' +(section.id== props.methodology.section ? "active" : "")}>
							<a onClick={(e) => changeMethodology(section.id, section.firstSubsection, section.firstIndicatorId)}>{ props.literals[section.name] }</a>
							<div className="caret"></div>
						</li>
					))}
				</ul>

				{/*  SUBSECTION MENU  */}			
				<ul className={`indicators--submenu--wrapper ${openIndicator ? 'open-list' : ''}`}  id="indicatorsSubmenu" onClick={openIndicatorsList} ref={dropdownRefContainer}>
					{levels.filter(level=>level.database_name!=undefined && level.database_name!='').map((subsection) => (
						<li key={subsection.id} className={'submenu--item '+(subsection.database_name== props.methodology.subsection ? 'active ' : '')+(props.literals[subsection.name].length > 20 ? 'multiline ' : '')}>
							<a onClick={(e) => changeMethodology( props.methodology.section, subsection.database_name, subsection.firstIndicatorId)}>{props.literals[subsection.name]}</a>
						</li>
					))}
				</ul>

				{/*  DROPDOWN LIST WITH INDICATORS  */}
				<form className="indicators--wrapper">
					<label htmlFor="indicators">{ props.literals.L20623 }</label>
					<div className="indicators-select">
						<select id="indicators" value={ props.methodology.indicator } onChange={ e => changeMethodology(props.methodology.section, props.methodology.subsection, e.target.value)}>
							{ indicators.map((indicator) => (
								<option key={indicator.indicatorID} value={indicator.indicatorID}>{ props.literals[`L${indicator.diagram}`] }</option>
							))}
						</select>
					</div>
				</form>
				
				{
					methodology != undefined ?
					(
						<section className={"methodology--grid--wrapper " + indicatorIcons(props.methodology.subsection)}>
							{ methodologySection('L20720',`L${methodology.diagram}`) }
							{ methodologySection('L20721',`L${methodology.description}`) }
							{ methodologySection('L20722',`L${methodology.datasource}`) }
							{ methodologySection('L20723',`L${methodology.specificTable}`) }
							{ methodologySection('L20724',`L${methodology.url}`) }
							{ methodologySection('L20728',`L${methodology.optionsApplied}`) }
							{ methodologySection('L20725',`L${methodology.referenceYear}`) }
							{ methodologySection('L20726',`L${methodology.lastUpdate}`) }
							{ methodologySection('L20727',`L${methodology.coverage}`) }
							{ methodologySection('L20730',`L${methodology.unitMeasure}`) }
							{ methodologySection('L20729',`L${methodology.calculations}`) }
							{ methodologySection('L20731',`L${methodology.visualisation}`) }
							{ methodologySection('L20732',`L${methodology.additionalComments}`) }
						</section>
					) : (
						<section className="methodology--grid--wrapper">

						</section>
					)
				}
			</div>
		</div>            
	);
}

function mapStateToProps(state){
    const { methodology } = state;
    return {
        methodology
    }
}

Methodology.displayName='Methodology';
export default connect(mapStateToProps, { setMethodology })(Methodology);